export var EBuySellFlag;
(function (EBuySellFlag) {
    EBuySellFlag["BUY"] = "B";
    EBuySellFlag["SELL"] = "S";
})(EBuySellFlag || (EBuySellFlag = {}));
